
<template>
  <div class="sky-remarks">
    <div
      @click="addVisible = true"
      v-bind:class="{addRemarkShow:isTrue}"
    >
      <el-button
        size="mini"
        v-bind:class="{isActive:isShow}"
      >添加备注</el-button>
    </div>
    <el-tabs
      v-model="activeName"
      @tab-click="handleClick"
    >
      <el-tab-pane
        label="备注"
        name="first"
      >
        <el-card
          class="box-card"
          v-for="(item,index) in remarkList"
          :key="index"
        >
          <div class="iconfont icon-beizhu1"></div>
          <div class="content-box">
            <ul>
              <li>{{item.creater}}</li>
              <li>{{item.createTime}}</li>
              <li
                class="iconfont icon-shanchu handle"
                @click.prevent="openremove(item,index)"
              ></li>
            </ul>
            <div class="inform">
              {{item.content}}
            </div>
          </div>
        </el-card>
        <section v-bind:class="{noData:hasData,'dataBox':not}">暂无数据</section>
      </el-tab-pane>
      <el-tab-pane
        label="日志"
        name="second"
      >
        <el-card
          class="box-card"
          v-for="(item,indexs) in logLists"
          :key="indexs"
        >
          <div class="iconfont icon-zhushi"></div>
          <div class="content-box">
            <ul>
              <li>{{item.createTime}}</li>
            </ul>
            <div class="inform">
              {{item.content}}
            </div>
          </div>
        </el-card>
        <section v-bind:class="{noData:loghasData,'dataBox':lognot}">暂无数据</section>
      </el-tab-pane>
    </el-tabs>

    <el-dialog
      title="添加备注"
      :visible.sync="addVisible"
      width="30%"
      @close='cancel'
    >
      <el-form ref="form">
        <el-form-item>
          <el-input
            type="textarea"
            v-model="form.content"
          ></el-input>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="cancel">取 消</el-button>
        <el-button
          type="primary"
          @click="add"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ajax from '@/backend/services/remark/remark.js'
export default {
  name: 'sky-remarks',
  props: ['id'],
  data() {
    return {
      isTrue: true,
      isShow: false,
      hasData: false,
      loghasData: false,
      lognot: true,
      not: true,
      activeName: 'first',
      remarkList: [],
      logLists: '',
      addVisible: false,
      form: {
        content: '',
        correlationId: this.id
      }
    }
  },
  watch: {
    isTrue() {
      this.isTrue == true ? (this.isShow = false) : (this.isShow = true)
    }
  },
  methods: {
    cancel() {
      this.addVisible = false
      this.form.content = ''
    },
    // tab事件
    handleClick(tab) {
      if (tab.name == 'second') {
        this.logList()
        this.isTrue = false
        this.isShow = true
      } else if (tab.name == 'first') {
        this.isShow = false
        this.isTrue = true
      }
    },
    openremove(item, index) {
      this.$confirm('是否删除该条备注?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.remove(item, index)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    async remove(item, index) {
      let datas = await ajax.getRemoveTask({ id: item.id })
      if (datas.status == 204 || datas.status == 200) {
        this.remarkList.splice(index, 1)
        this.taskList()
      }
    },
    async add() {
      this.addVisible = true
      let datas = await ajax.addTask(this.form)
      if (datas.status == 201 || datas.status == 200) {
        this.$message.success('添加备注成功')
        this.addVisible = false
        this.form.content = ''
        this.taskList()
      }
    },
    async taskList() {
      //备注列表
      let page = {
        displayLength: 10,
        displayStart: 0,
        id: this.id
      }
      let datas = await ajax.taskList(page)
      this.remarkList = datas.data.data
      if (this.remarkList.length > 0) {
        this.hasData = false
        this.not = true
      } else {
        this.hasData = true
        this.not = false
      }
    },
    // 获取日志
    async logList() {
      let page = {
        displayLength: 10,
        displayStart: 0,
        id: this.id
      }
      let datas = await ajax.logList(page)
      this.logLists = datas.data.data
      this.logLists = datas.data.data
      if (this.logLists.length > 0) {
        this.loghasData = false
        this.lognot = true
      } else {
        this.loghasData = true
        this.lognot = false
      }
    }
  },
  mounted() {
    this.taskList()
  }
}
</script>

<style scoped lang="scss">
.sky-remarks {
  position: relative;
  padding: 11px;
  background: #ffffff;
  .box-card {
    padding-top: 6px;
    padding-left: 12px;
    padding-bottom: 15px;
    margin-bottom: 10px;
    box-shadow: none;
    border-top: 1px solid #e3e5ec;
    border-bottom: 1px solid #e3e5ec;
    ul {
      width: 100%;
      li {
        float: left;
      }
      li:nth-child(1) {
        font-size: 14px;
      }
      li:nth-child(2) {
        margin-left: 10px;
        color: #999999;
        font-size: 6px;
      }
      li:nth-child(3) {
        float: right;
      }
    }
    .inform {
      clear: both;
      color: #333333;
      font-size: 14px;
      margin-top: 25px;
    }
  }
  .addRemarkShow {
    position: absolute;
    top: 12px;
    right: 20px;
    z-index: 100;
  }
  .isActive {
    display: none;
  }
  .noData {
    display: block;
    width: 100%;
    height: 100px;
    text-align: center;
    line-height: 100px;
  }
  .dataBox {
    display: none;
  }
  .handle {
    cursor: pointer;
  }
  .handle:hover {
    color: #54a8fe;
  }
}
.icon-beizhu1 {
  float: left;
  font-size: 30px;
  margin-right: 20px;
  color: #54a8fe;
}
.content-box {
  width: 91%;
  float: left;
}
.icon-shanchu {
  font-size: 14px;
}
</style>
